import { Fab, Paper } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import styled from "styled-components";

export const Container = styled(Paper)`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 28px;
  height: 82vh;

  h2 {
    margin-bottom: 30px;
  }
  .super-app-thme--disabled{
    opacity: 0.5;
  }
`;

export const InviteButton = styled(Button)`
  width: 100%;
  background: var(--primary);
  color: #fff;
`;

export const ButtonContainer  = styled.div`
  align-self: flex-end;
  margin-top: 28px;

`;

export const Title = styled.h2``;

export const UsersTable = styled(DataGrid)``;

export const AddButton = styled(Fab)``;

